// extracted by mini-css-extract-plugin
export default {"info":"delete-resource-modal_info__JjfEW","text":"delete-resource-modal_text__Auifl","button":"delete-resource-modal_button__mZi-F"};